var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"solinftec-pwa-histogram"}},[_c('v-main',[_c('v-container',{staticClass:"pa-0 ma-0 justify-center",attrs:{"fluid":""}},[(_vm.viewMode == 'H')?_c('Chart'):_c('Summary')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }